
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.34 12.35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-2",attrs:{"fill":"#f8bf13","d":"M6.17 1.76a4.42 4.42 0 104.43 4.42 4.43 4.43 0 00-4.43-4.42zm0 7.53c-1.72 0-3.12-1.4-3.12-3.12s1.4-3.12 3.12-3.12 3.12 1.4 3.12 3.12-1.4 3.12-3.12 3.12z"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#ce952e","d":"M6.82 1.49V.65c0-.36-.29-.65-.65-.65s-.65.29-.65.65v.84c.21-.04.43-.05.65-.05s.44.01.65.05zm-1.3 9.37v.84c0 .36.29.65.65.65s.65-.29.65-.65v-.84c-.21.04-.43.05-.65.05s-.44-.01-.65-.05zM.65 5.52c-.36 0-.65.29-.65.65s.29.65.65.65h.83c-.04-.21-.05-.43-.05-.65s.01-.44.05-.65H.65zm5.85.32V4.53c-.1-.02-.22-.03-.33-.03s-.22 0-.33.03v1.31H4.53c-.02.1-.03.22-.03.33s0 .22.03.33h1.31v1.31c.1.02.22.03.33.03s.22 0 .33-.03V6.5h1.31c.02-.1.03-.22.03-.33s0-.22-.03-.33H6.5zm5.2-.32h-.83c.04.21.05.43.05.65s-.01.44-.05.65h.83c.36 0 .65-.29.65-.65s-.29-.65-.65-.65z"}})])
          )
        }
      }
    